// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebar {
  width: 250px;
  background-color: #f4f4f4;
  overflow-y: auto; /* Enables vertical scrolling */

  position: fixed; /* Keeps sidebar fixed on the left */
  left: 0;
 margin-top:100%;
  padding: 0;
}

.sidebar ul {
  
  list-style-type: none;
  padding: 0;
  margin-top:15%;
}

.sidebar li {
  padding: 15px;
  margin: 5px 0;
 
  cursor: pointer;
  background-color: white;
  border-radius:6px 0 0 6px;
  /* border: 1px solid #ddd;  */
  transition: background-color 0.3s;
}

.sidebar li:hover {
  background-color: #ddd;
}



.sidebar .icon {
  font-size: 20px;
  margin-right: 15px;
  color: #555;
}

.sidebar .menu-text {
  font-size: 16px;
  color: #333;
}


/* Sidebar.css */
.view-profile {
  padding: 1%;
  cursor: pointer;
  margin-top: 10%;
  text-align: center;
}

.view-profile-text {
  color: #007bff;
  cursor: pointer;
  transition: color 0.3s;
}

.view-profile-text:hover {
  color: #0056b3;
}

/* Active menu item */
.sidebar li.active {
  background: #ddd; /* Active item background */
  color: white; /* Active text color */
  font-weight: bold;
}


/* Bottom Navigation Bar for Mobile */
.bottom-nav {
  display: none; /* Hidden on desktop */
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  z-index: 1000;
}


/* Mobile menu overlay */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.46);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}



/* Mobile menu container */
.mobile-menu {
  background: white;
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  padding: 20px;
  margin-top: 80%;
  text-align: left;
  position: relative;
  box-shadow: #282222;
  animation: popUp 0.3s ease-out;
}
.mobile-menu::before {
  content: "";
  position: absolute;
  bottom: -10px;
  right: 10px;
  width: 0;
  height: 0;
  border-left: 30px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid white; /* Arrow pointing up */
}

.mobile-menu ul {
  display: grid;
  margin-left: -4%;
  grid-template-columns: repeat(3, 1fr); /* Three items per row */
  gap: 15px;
  text-align: center;
  padding: 10px;
}

.mobile-menu li {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 8px;
  transition: background 0.3s;
}

.mobile-menu li.active {
  background: rgba(200, 200, 200, 0.364);
}

.mobile-menu .icon {
  font-size: 24px;
  color: black;
}

.mobile-menu .menu-text {
  font-size: 14px;
  margin-top: 5px;
  color: black;
}


/* Close button */
.close-menu {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: black;
}

/* Pop-up animation */
@keyframes popUp {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Hide bottom navigation on desktop */
@media (min-width: 768px) {
  .bottom-nav {
    display: none;
  }
}

/* Show Bottom Nav only in Mobile */
@media screen and (max-width: 768px) {
  .bottom-nav {
    display: flex; /* Visible only on mobile */
    position: fixed;
  }

  .sidebar {
    display: none; /* Hide sidebar on mobile */
  }
}

/* Bottom Nav Buttons */
.bottom-nav button {
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  color: gray;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: color 0.3s ease;
}

.bottom-nav button.active {
  color: #004DC6; /* Highlight active button */
}
.bottom-nav button svg {
  font-size: 28px;
}

.keyboard-open .bottom-nav {
  transform: translateY(100%); /* Moves navbar off-screen when keyboard opens */
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Sidebar.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB,EAAE,+BAA+B;;EAEjD,eAAe,EAAE,oCAAoC;EACrD,OAAO;CACR,eAAe;EACd,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;;EAEb,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;;;AAIA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;;AAGA,gBAAgB;AAChB;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY,EAAE,sBAAsB;EACpC,iBAAiB;AACnB;;;AAGA,qCAAqC;AACrC;EACE,aAAa,EAAE,sBAAsB;EACrC,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,aAAa;AACf;;;AAGA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;;;AAIA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B,EAAE,sBAAsB;AACtD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC,EAAE,wBAAwB;EAC/D,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;;AAGA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa,EAAE,2BAA2B;IAC1C,eAAe;EACjB;;EAEA;IACE,aAAa,EAAE,2BAA2B;EAC5C;AACF;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,4BAA4B;AAC9C;AACA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B,EAAE,gDAAgD;AAC/E","sourcesContent":["\n.sidebar {\n  width: 250px;\n  background-color: #f4f4f4;\n  overflow-y: auto; /* Enables vertical scrolling */\n\n  position: fixed; /* Keeps sidebar fixed on the left */\n  left: 0;\n margin-top:100%;\n  padding: 0;\n}\n\n.sidebar ul {\n  \n  list-style-type: none;\n  padding: 0;\n  margin-top:15%;\n}\n\n.sidebar li {\n  padding: 15px;\n  margin: 5px 0;\n \n  cursor: pointer;\n  background-color: white;\n  border-radius:6px 0 0 6px;\n  /* border: 1px solid #ddd;  */\n  transition: background-color 0.3s;\n}\n\n.sidebar li:hover {\n  background-color: #ddd;\n}\n\n\n\n.sidebar .icon {\n  font-size: 20px;\n  margin-right: 15px;\n  color: #555;\n}\n\n.sidebar .menu-text {\n  font-size: 16px;\n  color: #333;\n}\n\n\n/* Sidebar.css */\n.view-profile {\n  padding: 1%;\n  cursor: pointer;\n  margin-top: 10%;\n  text-align: center;\n}\n\n.view-profile-text {\n  color: #007bff;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n\n.view-profile-text:hover {\n  color: #0056b3;\n}\n\n/* Active menu item */\n.sidebar li.active {\n  background: #ddd; /* Active item background */\n  color: white; /* Active text color */\n  font-weight: bold;\n}\n\n\n/* Bottom Navigation Bar for Mobile */\n.bottom-nav {\n  display: none; /* Hidden on desktop */\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: white;\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: space-around;\n  padding: 10px 0;\n  z-index: 1000;\n}\n\n\n/* Mobile menu overlay */\n.mobile-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.46);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n\n\n/* Mobile menu container */\n.mobile-menu {\n  background: white;\n  width: 100%;\n  max-width: 300px;\n  border-radius: 10px;\n  padding: 20px;\n  margin-top: 80%;\n  text-align: left;\n  position: relative;\n  box-shadow: #282222;\n  animation: popUp 0.3s ease-out;\n}\n.mobile-menu::before {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  right: 10px;\n  width: 0;\n  height: 0;\n  border-left: 30px solid transparent;\n  border-right: 20px solid transparent;\n  border-top: 20px solid white; /* Arrow pointing up */\n}\n\n.mobile-menu ul {\n  display: grid;\n  margin-left: -4%;\n  grid-template-columns: repeat(3, 1fr); /* Three items per row */\n  gap: 15px;\n  text-align: center;\n  padding: 10px;\n}\n\n.mobile-menu li {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  border-radius: 8px;\n  transition: background 0.3s;\n}\n\n.mobile-menu li.active {\n  background: rgba(200, 200, 200, 0.364);\n}\n\n.mobile-menu .icon {\n  font-size: 24px;\n  color: black;\n}\n\n.mobile-menu .menu-text {\n  font-size: 14px;\n  margin-top: 5px;\n  color: black;\n}\n\n\n/* Close button */\n.close-menu {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: transparent;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: black;\n}\n\n/* Pop-up animation */\n@keyframes popUp {\n  from {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Hide bottom navigation on desktop */\n@media (min-width: 768px) {\n  .bottom-nav {\n    display: none;\n  }\n}\n\n/* Show Bottom Nav only in Mobile */\n@media screen and (max-width: 768px) {\n  .bottom-nav {\n    display: flex; /* Visible only on mobile */\n    position: fixed;\n  }\n\n  .sidebar {\n    display: none; /* Hide sidebar on mobile */\n  }\n}\n\n/* Bottom Nav Buttons */\n.bottom-nav button {\n  border: none;\n  background: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: gray;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: color 0.3s ease;\n}\n\n.bottom-nav button.active {\n  color: #004DC6; /* Highlight active button */\n}\n.bottom-nav button svg {\n  font-size: 28px;\n}\n\n.keyboard-open .bottom-nav {\n  transform: translateY(100%); /* Moves navbar off-screen when keyboard opens */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
